import { Box, Typography } from "@mui/material";
import { FlussMetadataOption } from "./fluss-node-panel-data";

export const sortedTableOptions = (tables: FlussMetadataOption[], label: (option: FlussMetadataOption) => string) =>
    [...tables].sort((a, b) => label(a).localeCompare(label(b), "pt-BR") || a.name.localeCompare(b.name, "pt-BR"));

export const renderTableOption = (props: React.HTMLAttributes<HTMLLIElement>, option: FlussMetadataOption, label: string) => (
    <Box component="li" {...props} key={option.id}>
        <Typography component="span">{label}</Typography>
        <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>{option.name}</Typography>
    </Box>
);
